export default __webpack_public_path__ + "static/media/eye_closed.9e499347.svg";